<template>
    <v-row v-if="event" class="calendar-event" no-gutters :class="[{'is-hover-view': isHoverView}]">
        <v-col cols="2" lg="1" align="center">
            <div class="calendar-event-color" :style="`background-color: ${event.event.color}`"/>
        </v-col>
        <v-hover v-slot="{ hover }">
            <v-col cols="10" lg="11" class="p-relative">
                <div class="calendar-event-name text-truncate">{{ event.event.name }}</div>
                <div class="calendar-event-info text-truncate">
                    {{ exercisesSets }}
                </div>
                <div v-if="hover" class="calendar-event-actions">
                    <button-tooltip
                        v-if="!isCircuit"
                        @click="$emit('click:show')"
                        fab text x-small
                        :tooltip="$t('tooltips.edit_exercise')"
                    >
                        <v-icon>$edit</v-icon>
                    </button-tooltip>
                    <button-tooltip
                        @click="$emit('click:delete')"
                        fab text x-small
                        :tooltip="event.event.isCircuit ? $t('tooltips.delete_circuit') : $t('tooltips.delete_exercise')"
                    >
                        <v-icon color="error">mdi-delete</v-icon>
                    </button-tooltip>
                </div>
            </v-col>
        </v-hover>
    </v-row>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";
export default {
    name: "ExerciseEvent",
    components: {ButtonTooltip},
    props: {
        event: {
            type: Object,
            default: null,
        },
        isHoverView: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isCircuit(vm = this) {
            return vm.event.event.isCircuit || false
        },
        exercisesSets(vm = this) {
            if (vm.isCircuit) {
                let quantitySets = vm.event.event.sets
                let value = vm.event.event.config.value
                let type = vm.$t(`exercises.short_${vm.event.event.config.type}`)
                return `${quantitySets}x${value}${type}`
            }

            let config = vm.event.event.sets || vm.event.event.config || null
            if (!config || (config && (config.sets.length === 0 || config?.sets[0]?.data.length === 0))) return vm.$t('common.not_available_short')
            let quantitySets = config.sets.length
            let type = vm.$t(`exercises.${config.sets[0].data[0].short_name}`)

            let result = ''
            if (quantitySets === 1) {
                result = `${quantitySets}x${config.sets[0].data[0].value}${type}`
            } else {
                let values = []
                let current = null
                let sameValue = true
                config.sets.forEach(set => {
                    if (!current) current = set.data[0].value
                    values.push(set.data[0].value)
                    if (current !== set.data[0].value) sameValue = false
                    current = set.data[0].value
                })

                if (sameValue) {
                    result = `${quantitySets}x${values[0]}${type}`
                } else {
                    result = `${quantitySets}x${values.join(`${type},`)}${type}`
                }
            }
            return result
        },
    }
}
</script>

<style scoped>

.calendar-event {
    border-bottom: 1px solid #D9D9D9;
}

.calendar-event-color {
    border-radius: 11px;
    height: 21px;
    width: 6px;
}

.calendar-event-name {
    font-weight: 300;
    font-size: 12px;
    line-height: 12px;
    color: #03342C;
}

.calendar-event-info {
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: #03342C;
}

.calendar-event-actions {
    position: absolute;
    right: 0;
    top: -8px;
    background-color: #FFFFFF;
}

.is-hover-view {
    padding-top: 4px;
    padding-bottom: 2px;
}

</style>